/**
 * System alert utilities
 */

/**
 * Get the VIP duration message based on registration method
 * @param {Object} data - Registration response data containing information about VIP duration
 * @returns {string} - The VIP duration message
 */
export function getVipDurationMessage(data) {
  let vipDays = 0;
  
  if (data.vipDays) {
    vipDays = data.vipDays;
  } else {
    // Fallback values based on registration method
    if (data.usedSpecialCode) {
      vipDays = 45; // SPECIAL_CODE_VIP_DURATION
    } else if (data.usedInviteCode) {
      vipDays = 30; // INVITATION_CODE_VIP_DURATION
    } else {
      vipDays = 15; // DEFAULT_VIP_DURATION
    }
  }
  
  return `欢迎来到即答，您已获得${vipDays}天VIP会员!`;
}

/**
 * Show a system alert
 * This function can be used throughout the application to display consistent system alerts
 * 
 * @param {Object} vm - Vue component instance
 * @param {Object} options - Alert options
 * @param {string} options.title - Alert title
 * @param {string} options.message - Alert message
 * @param {string} options.buttonText - Button text
 * @param {Function} options.onClose - Callback function when alert is closed
 */
export function showSystemAlert(vm, options = {}) {
  vm.systemAlertTitle = options.title || '系统提示';
  vm.systemAlertMessage = options.message || '';
  vm.systemAlertButtonText = options.buttonText || '确定';
  vm.systemAlertOnClose = options.onClose || null;
  vm.showSystemAlert = true;
} 